import React from 'react';
import { makeStyles } from '@material-ui/core';
import { Check } from '@material-ui/icons';

const useStyles = makeStyles({
  root: {
    width: 18,
    height: 18,
    flexShrink: 0,
    boxSizing: 'border-box',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  done: { backgroundColor: '#2e9e4f', color: '#fff' },
  partial: { border: '2px solid #e8a33d', backgroundColor: '#fdf0d5' },
  empty: { border: '2px solid #cfd5de', backgroundColor: '#fff' },
  icon: { fontSize: 12 },
});

interface IProps {
  filled: number;
  total: number;
}

const RatingStatusIcon = ({ filled, total }: IProps) => {
  const classes = useStyles();

  if (total > 0 && filled >= total) {
    return (
      <span className={`${classes.root} ${classes.done}`}>
        <Check className={classes.icon} />
      </span>
    );
  }

  const stateClass = filled > 0 ? classes.partial : classes.empty;
  return <span className={`${classes.root} ${stateClass}`} />;
};

export default RatingStatusIcon;
